// extracted by mini-css-extract-plugin
export default {"instructions":"src-modules-session-sales-institution-reservations-assign-select-institution-user-style__instructions_9fy5H"};